export const ACTION_START = 'ACTION_START';
export const ACTION_SUCCESS = 'ACTION_START_SUCCESS';
export const ACTION_ERROR = 'ACTION_ERROR';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const CHANGE_STEP = 'CHANGE_STEP';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const UPDATE_CONTRACT_DETAILS = 'UPDATE_CONTRACT_DETAILS';
export const FECTH_FEES_SUCCESS = 'FECTH_FEES_SUCCESS';
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS';
export const CLEAR_DATA = 'CLEAR_DATA';
export const ADD_MUSATEH_SUCCESS = 'ADD_MUSATEH_SUCCESS';
export const DELETE_MUSATEH_SUCCESS = 'DELETE_MUSATEH_SUCCESS';
export const RESET_ERROR = 'RESET_ERROR';
export const UPDATE_MUSATAHA_CONTRACT_STATE_BY_KEY_VALUE = 'UPDATE_MUSATAHA_CONTRACT_STATE_BY_KEY_VALUE';
